module.exports = {
  title: 'Featured Stories',
  context: {
    heading: 'Stories',
    shortDescription: 'Celebrating voices of our community',
    stories: [
      {
        image: {
          src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/ava-green.jpg?mtime=20210622121530&focal=none',
          alt: 'Ava Green',
          lazy: true,
          height: 600,
          width: 500
        },
        heading: 'Ava Green',
        shortDescription: 'Senior Director\nFresno, CA',
        url: '/'
      },
      {
        image: {
          src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/ava-green.jpg?mtime=20210622121530&focal=none',
          alt: 'Ava Green',
          lazy: true,
          height: 600,
          width: 500
        },
        heading: 'John Taylor',
        shortDescription: 'Navy Veteran\nSan Diego, CA',
        url: '/'
      },
      {
        image: {
          src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/ava-green.jpg?mtime=20210622121530&focal=none',
          alt: 'Ava Green',
          lazy: true,
          height: 600,
          width: 500
        },
        heading: 'Nora James',
        shortDescription: 'Human Resources Specialist\nFresno, CA',
        url: '/'
      }
    ]
  },
  variants: [
    {
      name: 'Two Cards',
      heading: 'Stories',
      shortDescription: 'Celebrating voices of our community',
      stories: [
        {
          image: {
            url: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/ava-green.jpg?mtime=20210622121530&focal=none',
            alt: 'Ava Green'
          },
          heading: 'Ava Green',
          shortDescription: 'Senior Director\nFresno, CA',
          url: '/'
        },
        {
          image: {
            url: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/ava-green.jpg?mtime=20210622121530&focal=none',
            alt: 'John Taylor'
          },
          heading: 'John Taylor',
          shortDescription: 'Navy Veteran\nSan Diego, CA',
          url: '/'
        }
      ]
    },
    {
      name: 'One Card',
      heading: 'Stories',
      shortDescription: 'Celebrating voices of our community',
      stories: [
        {
          image: {
            url: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/ava-green.jpg?mtime=20210622121530&focal=none',
            alt: 'Ava Green'
          },
          heading: 'Ava Green',
          shortDescription: 'Senior Director\nFresno, CA',
          url: '/'
        }
      ]
    }
  ]
}
